<div class="screen-element showvalue">
	<div class="title" [ngClass]="{'dark':hasParameter('darkTitle'),'light':lightTitle,'darkerTitle':hasParameter('darkerTitle')}">{{title|uppercase}}</div>
	<div class="subtitle" [ngClass]="{'dark':hasParameter('darkSubtitle'),'light':hasParameter('lightSubtitle')}">{{subTitle|uppercase}}</div>
	<div *ngIf="hasParameter('smallValue')" class="settingsvalue-center" >
			<div class="value background smallValue" [ngClass]="{'blink':isBlinking}" [ngStyle]="{'left':valueLeft}">{{getValue()}} {{getUnit()}}<span *ngIf="currentChar" class="currentChar">{{currentChar}}</span></div>
	</div>
	<div *ngIf="!hasParameter('smallValue')" class="settingsvalue-center" >
			<div class="value background" [ngClass]="{'blink':isBlinking}" [ngStyle]="{'left':valueLeft}">{{getValue()}}<span *ngIf="currentChar" class="currentChar">{{currentChar}}</span></div>
			<div class="unit">{{getUnit()}}</div>
	</div>
	
	<div *ngIf="showMarker" class="marker"></div>
	<div *ngIf="showTexts" [ngClass]="{'bright':brightText}">
		<div class="text text-1" [ngClass]="{'bright':brightText1}" >{{currentNode.getText(0)}}</div>
		<div class="text text-2" [ngClass]="{'bright':brightText2}">{{currentNode.getText(1)}}</div>
		<div class="text text-3" [ngClass]="{'bright':brightText3}">{{currentNode.getText(2)}}</div>
	</div>
	<div *ngIf="showTextInput" class="alphabet">
		<app-textinput [stringtype]="type" [text]="getValue()" (currentCharChanged)="currentCharChanged($event)" (onTextChanged)="textChanged($event)" (onSave)="saveText($event)"></app-textinput>
	</div>
</div>